import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  AsyncStateOverlayModule,
  EsprioSharedModule,
  NavBarModule,
  RelativeAccountInterceptor,
  RelativeAccountModule,
  SharedModule,
  SURVEY_LAYOUT_CONFIG,
} from 'ngx-esprio-shared';
import { AppRelativeAccountModule } from 'projects/nutrition/src/app/views/relative-account/app-relative-account.module';
import { environment } from '../environments/environment';
import { WEBK_SURVEY_LAYOUT_ONE_PAGE } from './views/survey/webk-survey-layout.config';
import { AppComponent } from './app.component';
import { AppInitializer } from './app.initializer';
import { routes } from './app.routes';
import { CoreStoreModule } from './store/core-store.module';
import { ViewsModule } from './views/views.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(routes, {
      enableTracing: false,
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
    }),
    RelativeAccountModule,
    AppRelativeAccountModule,
    CoreStoreModule,
    ViewsModule,
    NavBarModule,
    AsyncStateOverlayModule,
    SharedModule,
    EsprioSharedModule.forRoot({
      apiBaseUrl: environment.apiBaseUrl,
      environment: environment.environment,
      monitoringApp: environment.monitoringApp,
      disabledAppFeatures: environment.disabledAppFeatures,
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (translateService: TranslateService) => {
        return () => AppInitializer(translateService);
      },
      multi: true,
      deps: [TranslateService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RelativeAccountInterceptor,
      multi: true,
    },
    // WebK-only survey presentation (ticket 27754). The nutrition app does not
    // provide this token and keeps the legacy one-question-per-step behaviour.
    //
    // Two variants are available for comparison — swap the import above and the
    // value below to switch:
    //   WEBK_SURVEY_LAYOUT          → intro + one screen per section
    //   WEBK_SURVEY_LAYOUT_ONE_PAGE → intro + everything on one scrollable page
    {
      provide: SURVEY_LAYOUT_CONFIG,
      useValue: WEBK_SURVEY_LAYOUT_ONE_PAGE,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
